import { TRUST_STATS } from "../data/site";

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="bg-stone-50 border-y border-stone-200">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4">
        {TRUST_STATS.map((s, i) => (
          <div
            key={s.label}
            className={`px-5 py-8 md:py-10 lg:py-12 text-center md:text-left ${
              i !== TRUST_STATS.length - 1 ? "md:border-r border-stone-200" : ""
            } ${i < 2 ? "border-b md:border-b-0 border-stone-200" : ""}`}
            data-testid={`trust-stat-${i}`}
          >
            <div className="font-display text-4xl md:text-5xl font-black text-stone-900 tracking-tighter leading-none">
              {s.value}
            </div>
            <div className="mt-2 text-[11px] uppercase tracking-[0.22em] text-stone-500 font-semibold">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
